import React from 'react';
import {Link as RouterLink} from "react-router-dom";
import {Box, Container, Link, Stack, Typography} from "@mui/material";

import BrandMark from "./BrandMark";

const LINK_GROUPS = [
    {
        label: 'Tools',
        links: [
            {label: '전체 도구', to: '/'},
            {label: '업데이트 내역', to: '/update'},
        ],
    },
];

const linkStyle = {
    color: 'text.secondary',
    textDecoration: 'none',
    ':hover': {color: 'primary.main'},
} as const;

export const Footer = () => {
    return (
        <Box component="footer" sx={{borderTop: '1px solid', borderColor: 'divider', marginTop: 'auto'}}>
            <Container maxWidth="md">
                <Stack
                    direction={{xs: 'column', sm: 'row'}}
                    spacing={{xs: 3, sm: 6}}
                    sx={{paddingTop: 4, paddingBottom: 4}}
                >
                    <Stack spacing={1.25} sx={{flexGrow: 1}}>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                            <BrandMark height={22} title="MakerKSH"/>
                            <Typography variant="subtitle2" sx={{fontWeight: 800}}>
                                MakerKSH <Box component="span" sx={{fontWeight: 600, color: 'text.secondary'}}>Utils</Box>
                            </Typography>
                        </Stack>
                        <Typography variant="mono" sx={{color: 'text.disabled'}}>
                            © {new Date().getFullYear()} MakerKSH
                        </Typography>
                    </Stack>

                    {LINK_GROUPS.map((group) => (
                        <Stack key={group.label} spacing={1} sx={{minWidth: 96}}>
                            <Typography variant="overline" sx={{color: 'text.disabled'}}>
                                {group.label}
                            </Typography>
                            {group.links.map((link) => (
                                <Link key={link.to} component={RouterLink} to={link.to} variant="body2" sx={linkStyle}>
                                    {link.label}
                                </Link>
                            ))}
                        </Stack>
                    ))}

                    <Stack spacing={1} sx={{minWidth: 96}}>
                        <Typography variant="overline" sx={{color: 'text.disabled'}}>
                            Maker
                        </Typography>
                        <Link
                            href="https://github.com/SeHyun-Kim04"
                            target="_blank"
                            rel="noopener"
                            variant="body2"
                            sx={linkStyle}
                        >
                            GitHub
                        </Link>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};
